import { Pipe, PipeTransform } from '@angular/core';
import Fuse from 'fuse.js';

@Pipe({
  name: 'suggestedSearch',
  pure: false,
  standalone: true,
})
export class SuggestedSearchPipe implements PipeTransform {
  transform(list: any[], keys: string[], keyword: string): any {
    if (!list) return [];
    if (!keyword) return list;
    if (keyword && keyword.length >= 25) return [];

    const options = {
      includeScore: true,
      threshold: 0.4,
      keys, // keys you want to search on
    };

    return new Fuse(list, options).search(keyword).map((i) => i.item);
  }
}
